module.exports = __webpack_public_path__ + "static/media/hostplatform-icon.b3bfd4ca.png";